import { clsx } from 'clsx';
import type * as React from 'react';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaTimesCircle } from 'react-icons/fa';

interface IProps {
  /**
   * Severity level of the alert
   */
  severity: 'success' | 'info' | 'warning' | 'error';
  /**
   * Optional class for the whole alert component
   * @default my-4 first:mt-0
   */
  className?: string;
  /**
   * Content of the alert
   */
  children: React.ReactNode[] | React.ReactNode | string;
}

/**
 *
 * @param props IProps
 */
export const Alert = (props: IProps) => {
  const { severity, children, className = 'my-4 first:mt-0' } = props;

  return (
    <div
      className={clsx(className, 'flex items-center rounded px-5 py-3 text-sm', {
        'bg-green-100': severity === 'success',
        'bg-red-100': severity === 'error',
        'bg-blue-100': severity === 'info',
        'bg-yellow-100': severity === 'warning',
      })}
    >
      <div className="mr-4">
        {severity === 'error' && <FaTimesCircle className="text-red-700" />}
        {severity === 'success' && <FaCheckCircle className="text-green-700" />}
        {severity === 'info' && <FaInfoCircle className="text-blue-700" />}
        {severity === 'warning' && <FaExclamationTriangle className="text-yellow-700" />}
      </div>
      <div>{children}</div>
    </div>
  );
};
